import React, { ComponentProps, ForwardedRef, forwardRef, PropsWithChildren } from 'react'

import { bemJoin } from 'bem-join'

import { classNames } from '@app/lib/bem'
import { MergeProps } from '@app/lib/types'

export type CardHeaderProps = MergeProps<
  ComponentProps<'div'>,
  {
    variant?: 'light'
  }
>

const b = bemJoin('lawyer-card')

export const CardHeader = forwardRef(
  (
    { variant, children, className, ...rest }: PropsWithChildren<CardHeaderProps>,
    forwardedRef: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={classNames(
          b('head', {
            ...(variant && { [variant]: true })
          }),
          className
        )}
        {...rest}
      >
        {children}
      </div>
    )
  }
)
